<template>
  <div>
    <!-- print -->
    <div class="print" style="display: block">
      <!-- main -->
      <div class="col-12">
        <div class="row no-printable">
          <div
            class="col-12 mb-2 d-flex justify-space-between align-center mt-5 no-printable"
          >
            <div class="title-admin mt-0">
              <h1 class="display-3 font-weight-black mr-0 mb-0 pm-0 pt-0">
                Ventas
              </h1>
            </div>
            <v-btn color="red darken-1" dark large @click="$router.go(-1)"
              ><v-icon class="mr-3">close</v-icon>Salir</v-btn
            >
          </div>
        </div>

        <div class="row mt-4 filtrar-admin no-printable">
          <div class="col-4">
            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="desde"
              persistent
              full-width
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="desde"
                  label="Desde"
                  prepend-icon="event"
                  readonly
                  outlined
                  background-color="#ffffff"
                  v-on="on"
                ></v-text-field>
              </template>

              <v-date-picker v-model="desde">
                <v-btn text color="primary" @click="$refs.dialog.save(desde)"
                  >OK</v-btn
                >
                <v-btn text color="primary" @click="modal = false"
                  >Cancelar</v-btn
                >
              </v-date-picker>
            </v-dialog>
          </div>

          <div class="col-4">
            <v-dialog
              ref="dialog2"
              v-model="modal2"
              :return-value.sync="hasta"
              persistent
              full-width
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="hasta"
                  label="Hasta"
                  prepend-icon="event"
                  readonly
                  outlined
                  v-on="on"
                ></v-text-field>
              </template>

              <v-date-picker v-model="hasta">
                <v-btn text color="primary" @click="$refs.dialog2.save(hasta)"
                  >OK</v-btn
                >
                <v-btn text color="primary" @click="modal2 = false"
                  >Cancelar</v-btn
                >
              </v-date-picker>
            </v-dialog>
          </div>

          <div class="col-4 d-flex justify-space-between mt-1">
            <v-btn @click="getVentasFiltradas()" large color="grey" dark>
              <v-icon class="mr-3">settings_overscan</v-icon>
              Filtrar
            </v-btn>
            <v-btn @click="resetFiltro()" outlined large color="grey" dark
              >Borrar filtro</v-btn
            >
          </div>
        </div>

        <!-- tabla de ventas -->
        <div class="row mt-0 mb-5">
          <div class="col-12">
            <div>
              <div
                class="top d-flex align-items-center justify-content-between mb-3"
              >
                <h5
                  class="font-weight-black"
                  v-if="showDesdeTitle && !showHastaTitle"
                >
                  Todas las ventas de la fecha {{ desde }}
                  <br />
                  <h1 class="font-weight-black">
                    Total: ${{ total_ventas_dia }}
                  </h1>
                </h5>
                <h5
                  class="font-weight-black"
                  v-if="showDesdeTitle && showHastaTitle"
                >
                  Todas las ventas desde la fecha {{ desde }} hasta {{ hasta }}
                  <br />
                  <h1 class="font-weight-black">
                    Total: ${{ total_ventas_rango }}
                  </h1>
                </h5>
                <h2 class="font-weight-black" v-if="!showDesdeTitle">
                  Todas las ventas
                </h2>

                <v-btn @click="print()" large color="primary"
                  ><v-icon class="mr-3">print</v-icon>Imprimir</v-btn
                >
              </div>

              <!-- loader -->
              <div v-if="loaderVentas" class="text-center loader-wrap-min">
                <div
                  class="spinner-border text-primary"
                  style="width: 75px; height: 75px"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
              <!-- /loader -->

              <div v-if="!loaderVentas">
                <!-- datatable -->
                <v-card v-if="ventas != ''">
                  <v-card-title>
                    <v-text-field
                      v-model="search"
                      append-icon="search"
                      label="Buscar"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                  <v-data-table
                    :headers="headers"
                    :items="ventas"
                    :search="search"
                  >
                    <template v-slot:item.estatus="{ item }">
                      <div v-if="item.estatus == 'pagada'">
                        <span class="badge badge-success">Pagada</span>
                      </div>
                      <div v-else>
                        <span class="badge badge-danger">Pago parcial</span>
                      </div>
                    </template>
                    <template v-slot:item.entregada="{ item }">
                      <div v-if="item.entregada == '1'">
                        <span class="badge badge-success">Entregada</span>
                      </div>
                      <div v-else>
                        <span class="badge badge-danger">No Entregada</span>
                      </div>
                    </template>
                    <template v-slot:item.acciones="{ item }">
                      <v-btn
                        class="mx-2"
                        text
                        dark
                        small
                        color="primary"
                        :to="'/admin/venta/' + item.id"
                      >
                        <v-icon dark>visibility</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-card>
                <!-- /datatable -->

                <!-- vacio -->
                <div v-if="ventas == ''">
                  <div class="vacio">
                    <span>No hemos encontrado ventas</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /tabla de ventas -->
      </div>
      <!-- /main -->
    </div>
    <!-- /print -->
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
const axios = require("axios");
export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      //Date picker vuetify
      modal: false,
      desde: "",

      modal2: false,
      hasta: "",

      cobrar: false,
      tipoCliente: "generico",
      loader: false,
      productos: "",
      buscar: "",
      total: "",
      precio_servicio: "",
      concepto_servicio: "",

      nombre_cliente: "",
      telefono_cliente: "",
      email_cliente: "",
      direccion_cliente: "",
      loaderVenta: false,

      buscar: "",
      buscarVentaInput: "",

      hoy: "",

      ventas: "",
      loaderVentas: false,

      total_ventas_dia: "",
      total_ventas_rango: "",

      items: [],

      showDesdeTitle: false,
      showHastaTitle: false,

      //Table
      search: "",
      headers: [
        {
          text: "#ID",
          align: "left",
          sortable: false,
          value: "id",
        },
        { text: "Fecha", value: "fecha" },
        { text: "Monto", value: "monto" },
        { text: "Cliente", value: "cliente", class: "addSign" },
        { text: "Teléfono", value: "telefono" },
        { text: "Estatus", value: "estatus" },
        { text: "Entregado", value: "entregada" },

        { text: "Acciones", value: "acciones" },
      ],
    };
  },
  methods: {
    resetFiltro() {
      this.getVentas();
      this.desde = "";
      this.hasta = "";
      this.showDesdeTitle = false;
      this.showHastaTitle = false;
    },
    customFormatter(date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a");
    },
    getVentas() {
      this.loaderVentas = true;
      //Obtenemos los productos
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getVentas"
        )
        .then((response) => {
          console.log(response);
          this.ventas = response.data;
          this.loaderVentas = false;
        })
        .catch((error) => console.log(error));
    },
    getVentasFiltradas() {
      if (this.desde == "" && this.hasta == "") {
        //No seleccionó ningún campo
        this.$swal({
          type: "error",
          customClass: "arriba",
          title: "Selecciona la fecha deseada",
          showConfirmButton: true,
        });
      } else if (this.desde != "" && this.hasta == "") {
        //Necesita ventas por día
        this.loaderVentas = true;
        this.showDesdeTitle = true;

        //Traemos ventas del día
        axios
          .get(
            "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getVentasFiltradasPorDia" +
              "&dia=" +
              this.desde
          )
          .then((response) => {
            console.log(response);
            this.ventas = response.data;
            this.loaderVentas = false;
          })
          .catch((error) => console.log(error));

        //Traemos el total del día
        axios
          .get(
            "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getTotalVentasDia" +
              "&dia=" +
              this.desde
          )
          .then((response) => {
            this.total_ventas_dia = response.data.total;
          })
          .catch((error) => console.log(error));
      } else if (this.desde == "" && this.hasta != "") {
        //Solo seleccionó la fecha hasta
        this.$swal({
          type: "error",
          customClass: "arriba",
          title:
            "Selecciona la fecha 'Desde' para crear un reporte por rango de fecha",
          showConfirmButton: true,
        });
      } else if (this.desde !== "" && this.hasta !== "") {
        //Necesita fecha por rango
        this.loaderVentas = true;
        this.showDesdeTitle = true;
        this.showHastaTitle = true;

        //Traemos las ventas por rango de fecha

        axios
          .get(
            "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getVentasFiltradasPorRangoFecha" +
              "&desde=" +
              this.desde +
              "&hasta=" +
              this.hasta
          )
          .then((response) => {
            console.log(response);
            this.ventas = response.data;
            this.loaderVentas = false;
          })
          .catch((error) => console.log(error));

        //Traemos total del día
        axios
          .get(
            "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getTotalVentasRangoFecha" +
              "&desde=" +
              this.desde +
              "&hasta=" +
              this.hasta
          )
          .then((response) => {
            this.total_ventas_rango = response.data.total;
          })
          .catch((error) => console.log(error));
      }
    },
    getVentasHoy() {
      this.loaderVentas = true;
      this.hoy = true;
      //Obtenemos los productos
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getVentasHoy"
        )
        .then((response) => {
          console.log(response);
          this.ventas = response.data;
          this.loaderVentas = false;
        })
        .catch((error) => console.log(error));
    },

    getVentasPorFecha() {
      //Validamos
      if (
        this.desde_mes == "" ||
        this.desde_ano == "" ||
        this.hasta_mes == "" ||
        this.hasta_ano == ""
      ) {
        //Mostramos alerta de error
        this.$swal({
          type: "error",
          customClass: "arriba",
          title: "Llena todos los campos necesarios para filtrar por fecha",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        let desde = this.desde_ano + "-" + this.desde_mes + "-" + "1";
        let hasta = this.hasta_ano + "-" + this.hasta_mes + "-" + "1";

        this.loaderVentas = true;
        //Obtenemos los productos
        axios
          .get(
            "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getVentasPorFecha&desde=" +
              desde +
              "&hasta=" +
              hasta
          )
          .then((response) => {
            console.log(response);
            this.ventas = response.data;
            this.loaderVentas = false;
          })
          .catch((error) => console.log(error));
      }
    },
    showCobrar() {
      this.cobrar = true;
    },
    closeCobrar() {
      this.cobrar = false;
      this.getVentas();
    },
    getVentasShow() {
      this.hoy = false;
      this.getVentas();
    },
    buscarConsulta() {
      this.loader = true;
      if (this.buscar != "") {
        axios
          .get(
            "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=searchProducto&search=" +
              this.buscar
          )
          .then((response) => {
            this.loader = false;
            this.productos = response.data;
          })
          .catch((error) => console.log(error));
      } else {
        //Obtenemos las productos
        axios
          .get(
            "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getProductos"
          )
          .then((response) => {
            this.productos = response.data;
            this.loader = false;
          })
          .catch((error) => console.log(error));
      }
    },
    getProductos() {
      //Obtenemos los productos
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getProductos"
        )
        .then((response) => {
          console.log(response.data);
          this.productos = response.data;
          this.loader = false;
        })
        .catch((error) => console.log(error));
    },
    agregarProductoOrden(id_producto, precio, imagen, nombre) {
      //Agregamos el item  al array
      this.items.push({
        id_producto: id_producto,
        precio: precio,
        imagen: imagen,
        cantidad: 1,
        nombre: nombre,
      });

      this.updateTotal();
    },
    agregarServicioOrden() {
      if (this.precio_servicio != "" && this.concepto_servicio != "") {
        //Agregamos el item  al array
        this.items.push({
          id_producto: "0",
          precio: this.precio_servicio,
          imagen:
            "https://vossmueblerias.com.mxhttps://vossmueblerias.com.mx/img/logo.eb8b33b4.png",
          cantidad: 1,
          nombre: this.concepto_servicio,
        });

        this.updateTotal();
      } else {
        this.$swal({
          type: "error",
          customClass: "arriba",
          title: "Llena los campos necesarios para el servicio",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
    borrarItem(index) {
      this.items.splice(index, 1);
      this.updateTotal();
    },
    updateTotal() {
      let sum = 0;
      for (let i = 0; i < this.items.length; i++) {
        sum +=
          parseFloat(this.items[i].precio) * parseFloat(this.items[i].cantidad);
      }

      this.total = sum;
    },
    buscarVenta() {
      this.loaderVentas = true;
      this.showDesdeTitle = false;
      this.showHastaTitle = false;

      this.desde = "";
      this.hasta = "";

      if (this.buscarVentaInput != "") {
        axios
          .get(
            "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=searchVenta&search=" +
              this.buscarVentaInput
          )
          .then((response) => {
            console.log(response);
            this.loaderVentas = false;
            this.ventas = response.data;
          })
          .catch((error) => console.log(error));
      } else {
        axios
          .get(
            "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getVentas"
          )
          .then((response) => {
            console.log(response);
            this.ventas = response.data;
            this.loaderVentas = false;
          })
          .catch((error) => console.log(error));
      }
    },
    print() {
      window.print();
    },
    saveVenta() {
      if (this.items == "") {
        this.$swal({
          type: "error",
          title: "Selecciona artículos para completar la venta",
          showConfirmButton: true,
        });
      } else if (this.tipoCliente != "generico" && this.nombre_cliente == "") {
        this.$swal({
          type: "error",
          title: "Ingresa el nombre del cliente",
          showConfirmButton: true,
        });
      } else if (
        this.tipoCliente != "generico" &&
        this.telefono_cliente == ""
      ) {
        this.$swal({
          type: "error",
          title: "Ingresa el teléfono del cliente",
          showConfirmButton: true,
        });
      } else if (this.tipoCliente != "generico" && this.email_cliente == "") {
        this.$swal({
          type: "error",
          title: "Ingresa el correo del cliente",
          showConfirmButton: true,
        });
      } else if (
        this.tipoCliente != "generico" &&
        this.direccion_cliente == ""
      ) {
        this.$swal({
          type: "error",
          title: "Ingresa la dirección del cliente",
          showConfirmButton: true,
        });
      } else {
        //Si el cliente es genérico
        if (this.tipoCliente == "generico") {
          this.nombre_cliente = "Cliente genérico";
          this.telefono_cliente = "No asignado";
          this.email_cliente = "No asignado";
          this.direccion_cliente = "No asignada";
        }

        //Convertimos variable
        this.items_j = JSON.stringify(this.items);

        this.loaderVenta = true;

        axios
          .get(
            "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=saveVenta" +
              "&nombre_cliente=" +
              this.nombre_cliente +
              "&telefono_cliente=" +
              this.telefono_cliente +
              "&email_cliente=" +
              this.email_cliente +
              "&direccion_cliente=" +
              this.direccion_cliente +
              "&items=" +
              this.items_j +
              "&total=" +
              this.total
          )
          .then((response) => {
            console.log(response);
            //Reseteamos valores
            this.items = [];
            this.tipoCliente = "generico";
            this.concepto_servicio = "";
            this.precio_servicio = "";
            this.total = "";

            this.nombre_cliente = "";
            this.telefono_cliente = "";
            this.email_cliente = "";
            this.direccion_cliente = "";

            this.laderVenta = false;
            this.$swal({
              type: "success",
              title: "La venta se creó exitosamente",
              showConfirmButton: true,
            });
          })
          .catch((error) => console.log(error));
      }
    },
  },

  computed: {
    updateCantidadItem(index, cantidad) {
      console.log(cantidad);
      this.items[index].cantidad = cantidad;
    },
  },

  mounted() {
    this.getProductos();
    this.getVentas();
  },
};
</script>
